



















































import {
  defineComponent,
  computed,
  ref,
  watch,
  useFetch,
  useContext,
} from '@nuxtjs/composition-api'
import uniqueid from 'lodash.uniqueid'
import { useProductStockRefresh } from '~/composables/product/useProduct'
import { Product } from '~/types/product'

export default defineComponent({
  name: 'BlocksSliderProduct',

  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    cols: {
      type: Number,
      default: 5,
    },
  },

  setup(props) {
    const uid = uniqueid('uid-')

    const swiperOptions = computed(() => {
      return {
        slidesPerView: 1,
        spaceBetween: 32,
        navigation: {
          nextEl: `.swiper-${uid} .gw-swiper-button-next`,
          prevEl: `.swiper-${uid} .gw-swiper-button-prev`,
        },
        breakpoints: {
          362: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          481: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: props.cols,
          },
        },
      }
    })

    const products = ref<Product[]>([])
    const { $api } = useContext()

    const { onProductsLoaded, refreshStocks } = useProductStockRefresh(products)

    const getProducts = async () => {
      const productCategoryId = props.data?.ProductCategoryID
      const productsData = props.data?.Products

      if (!productCategoryId && !productsData?.length) {
        // eslint-disable-next-line no-console
        console.error('ProductCategoryID or Products is missing')
      }

      if (productCategoryId) {
        products.value = await $api.product.getByWebNodeId(productCategoryId)
        onProductsLoaded()
      }

      if (productsData?.length) {
        const productIds = productsData
          .map((product: any) => product.ID)
          .join('&productIds=')
        products.value = await $api.product.getByIds(productIds)
      }
    }

    useFetch(async () => {
      await getProducts()
    })

    if (process.client) {
      watch(
        products,
        (products) => {
          if (products.length) {
            refreshStocks()
          }
        },
        {
          immediate: true,
        }
      )
    }

    return {
      uid,
      swiperOptions,
      products,
    }
  },
})
